var _defs, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWelcome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 112,
    viewBox: "0 0 120 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0902 86.8494H45.8109V25.1082H42.0814L39.636 27.0409V84.864L42.0902 86.8494Z",
    strokeLinejoin: "round",
    fill: "black",
    className: "welcome-logo-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 45.791 33.248 L 45.811 25.11 L 61.566 55.981 L 57.837 55.981 L 45.791 33.248 Z",
    strokeLinejoin: "round",
    fill: "black",
    className: "welcome-logo-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 73.636 83.012 L 73.608 86.844 L 57.853 55.979 L 61.563 55.979 L 73.617 79.605 L 73.636 83.012 Z",
    strokeLinejoin: "round",
    fill: "black",
    className: "welcome-logo-3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 73.635 32.521 L 73.652 25.088 L 71.22 30.021 L 59.662 52.263 L 61.564 55.981 L 73.635 32.521 Z",
    strokeLinejoin: "round",
    fill: "black",
    className: "welcome-logo-4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3289 25.1104H73.6082V86.8515H77.3377L79.7831 84.9188V27.0957L77.3289 25.1104Z",
    strokeLinejoin: "round",
    fill: "black",
    className: "welcome-logo-5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7164 110.387C29.6698 110.387 5.30724 86.0291 5.30724 55.978C5.30724 25.9313 29.6698 1.57318 59.7164 1.57318C89.7631 1.57318 114.126 25.9313 114.126 55.978C114.126 57.6389 114.051 59.2825 113.906 60.9055C111.415 88.6472 88.1024 110.387 59.7164 110.387ZM59.7164 0.219238C26.7379 0.219238 0 25.1866 0 55.9782C0 86.7743 26.7379 111.737 59.7164 111.737C92.695 111.737 119.433 86.7743 119.433 55.9782C119.433 25.1866 92.695 0.219238 59.7164 0.219238Z",
    strokeLinejoin: "round",
    fill: "black",
    className: "welcome-logo-6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWelcome);
export default __webpack_public_path__ + "static/media/logo-welcome.c3bbbf2e.svg";
export { ForwardRef as ReactComponent };